import React from 'react'
import { FormDependencyLoaderProvider } from '../components/context/FormDependencyLoaderContext'
import GetHelpBreadcrumbs from '../components/gethelp/GetHelpBreadcrumbs'
import ErrorFallback from '../components/common/ErrorFallback'
import { ErrorBoundary } from 'react-error-boundary'

export const GetHelpLayout = ({ children }) => {
  return (
    <>
      <div className="content-wrapper landing one-column" id="rfa-app">
        <GetHelpBreadcrumbs />
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <article className="main">
            <FormDependencyLoaderProvider>
              {children}
            </FormDependencyLoaderProvider>
          </article>
        </ErrorBoundary>
      </div>
    </>
  )
}
